module.exports = "<div class=\"ssf-paginator__wrapper\">\n    <div class=\"ssf-paginator__pagination\">\n        <pagination [boundaryLinks]=\"true\" [totalItems]=\"state.totalItems\" [(ngModel)]=\"state.pageInfo.page\"\n                    [itemsPerPage]=\"state.pageInfo.itemsPerPage\"  class=\"pagination-sm\" (pageChanged)=\"changePage($event)\"\n                    [maxSize]=\"pagesVisibleCount\"\n                    previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\"></pagination>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/paginator/paginator.component.html
// module id = 842
// module chunks = 3